import { CircleAlert } from "lucide-react"
import { useRouter } from "next/router"
import { Button, ButtonMode } from "shared-web/components/base/control/Button"
import { Icon, IconSizes } from "shared-web/components/Icon"

import { ErrorPageTitles, RundooHead } from "layouts/components/Head"
import { supportNumber } from "lib/constants"
import { urls } from "urls"

interface ErrorPageProps {
  message?: string
}

export function ErrorPage({
  message = `Please try again or contact Rundoo support at ${supportNumber("display")}`,
}: ErrorPageProps) {
  const router = useRouter()

  const handleGoToSales = () => {
    router.push(urls.sales())
  }

  return (
    <div className="dark:bg-gray-1000 flex h-screen w-screen flex-col items-center justify-center bg-gray-50 text-center">
      <RundooHead headTitle={ErrorPageTitles.ERROR} />

      <div className="flex flex-col items-center gap-y-6">
        <Icon
          icon={CircleAlert}
          size={IconSizes.ExtraExtraLarge}
          className="text-v2-foreground-danger"
        />

        <div className="flex flex-col gap-y-2">
          <h2 className="text-title-sm color-default">
            We encountered an error attempting to load this page
          </h2>
          <p className="text-body color-subtle">{message}</p>
        </div>

        <Button mode={ButtonMode.Primary} onClick={handleGoToSales}>
          Return to Transactions
        </Button>
      </div>
    </div>
  )
}
